import { v2Api } from '../v2Api';

export type RequestDatasetQuery = {
  business_value: string;
  controlling_ad_group: string;
  cost_center: string;
  data_classification: string;
  data_owners: Array<string>;
  dataset_name: string;
  dataset_primary_key: string;
  org_unit: string;
  primary_secondary_use_case: string[];
  use_case_description: string | null;
  user_id: string;
};

const tags = ['service-now', 'datasets'] as const;

const serviceNowApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      requestDataset: builder.mutation<object, RequestDatasetQuery>({
        query: ({ ...body }) => {
          return {
            url: `snow`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: tags,
      }),
    }),
  });

export default serviceNowApi;
